// frontend/src/features/auth/ForgotPassword.js
// This React component renders the Forgot Password page, allowing users to submit their email to request a password reset link, with success and error messages displayed after the request.
import React, { useState } from 'react';
import axios from 'axios';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError]     = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    try {
      const response = await axios.post(
        'http://localhost:5000/api/auth/forgot-password',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Error sending reset email');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Forgot Password</h2>

        {message && (
          <div className="mb-4 text-sm text-green-700 bg-green-100 p-3 rounded">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-4 text-sm text-red-700 bg-red-100 p-3 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="block text-gray-700 mb-2">
              Enter your email address
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded 
                         focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="you@example.com"
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-primary text-white rounded 
                       hover:bg-primary/90 transition"
          >
            Send Reset Email
          </button>
        </form>
      </div>
    </div>
  );
}
